import axios from 'axios';
import config from '../config';
import { rejectTransformer, resolveTransformer } from './interceptors';
import TokenService from './tokenService';

const DEFAULT_TIMEOUT = 180000;

const createApiInstance = (url) =>
    axios.create({
        withCredentials: true,
        timeout: DEFAULT_TIMEOUT,
        baseURL: url,
        headers: {
            Accept: 'application/json',
            'Content-Type': 'application/json',
            'Access-Control-Allow-Origin': '*',
        },
    });

const applyInterceptors = (instance) => {
    instance.interceptors.request.use((config) => {
        const token = TokenService.getAccessToken();
        config.headers.Authorization = `Bearer ${token}`;

        return config;
    });
    instance.interceptors.response.use(resolveTransformer, rejectTransformer);
};

const setAuthHeader = (instance, header) => {
    instance.defaults.headers.Authorization = header;
};

const removeAuthHeader = (instance) => {
    delete instance.defaults.headers.Authorization;
};

const baseInstance = createApiInstance(config.baseUrl);

function setToken(token) {
    modifyApiInstances(setAuthHeader, `Bearer ${token}`);
}

function removeToken() {
    modifyApiInstances(removeAuthHeader);
}

function modifyApiInstances(modificator, ...data) {
    [baseInstance].forEach((instance) => modificator(instance, ...data));
}

modifyApiInstances(applyInterceptors);

export { removeToken, setToken };

export default baseInstance;
